import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { CustomLabelRequest } from '../models/custom-label-request';
import { CustomLabelResponse } from '../models/custom-label-response';
import { CustomLabelHttpService } from './custom-label.http.service';

@Injectable()
export class CustomLabelStore {

  private currentCustomLabels: BehaviorSubject<CustomLabelResponse> = new BehaviorSubject(null);

  constructor(
    private flashMessagesService: FlashMessagesService,
    private customLabelHttpService: CustomLabelHttpService,
  ) {}

  get customLabels(): Observable<CustomLabelResponse> {
    return this.currentCustomLabels.asObservable();
  }

  /**
   * Has to be called to retrieve Custom Labels for a hotel or agency.
   * Is called by resolver.
   *
   * @param eventId
   * @returns CustomLabelResponse
   */
  loadCustomLabels(request: CustomLabelRequest): Observable<CustomLabelResponse> {
    return this.customLabelHttpService.geCustomLabels(request)
      .catch((error: any) => {
        this.flashMessagesService.error(
          'MESSAGES.ERROR.GET_CUSTOM_LABELS',
          `Could not retrieve the custom field labels: ${error}`
        );
        return Observable.throw(error);
      })
      .map((res: CustomLabelResponse) => {
        this.currentCustomLabels.next(res);
        return res;
      });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/custom-label.store.ts